// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { NewsPostData } = initSchema(schema);

export {
  NewsPostData
};